<template>
  <div class="traceability">
    <div class="tracingtop"><p>羽诗智能农业溯源平台</p></div>
    <div class="headerfile">
        <div class="monitor-time">
            {{nowTime}}
        </div>
        <div class="search">
          <div class="bb"></div>
          <router-link to="/search">
            溯源查询
          </router-link>
        </div>
    </div>
    <div class="sweepnumber"><div></div><div class="Sweep">扫码总量：<span class="number">{{mapAll.total}}</span>次</div><div></div></div> 
    <div class="chianamap">
      <div id="myChart"></div>
    </div>
    <div class="sweepnumber"><div></div><div class="ranking">全年扫码量排名</div><div></div></div> 
    <div class="provincial">
      <ol>
        <div class="picmsg">
          <div v-for="(item,index) in msg1" :key="index" class="picmsgli">
            <img :src="item.src"/>
          </div>
        </div>
        <div class="picli">
          <li v-for="(item,index) in topData[0]"  :key="index"><p class="provincialname">{{item.province}}</p><div class="provincialbj">{{item.num}}</div></li>
        </div>
      </ol>
      <ol>
        <div class="picmsg">
          <div v-for="(item,index) in msg2" :key="index" class="picmsgli">
            <img :src="item.src"/>
          </div>
        </div>
        <div class="picli">
          <li v-for="(item,index) in topData[1]"  :key="index"><p class="provincialname">{{item.province}}</p><div class="provincialbj">{{item.num}}</div></li>
        </div>
      </ol>
    </div>
    <div class="sweeptrend"><div></div><div class="Sweep">全年扫码量趋势</div><div></div></div> 
    <div class="drawline">
      <div id="myChartMap"></div>
    </div>
    <div class="emptiy">

    </div>
    <div class="indexbtn">
      <button @click="goodsList">溯源商品展示</button>
      <button @click="register" class="indexyuan">登录/注册</button>
    </div>
  </div>
</template>

<script>
//引入echarts地图组件 
import Vue from 'vue'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)

import { Toast } from 'mint-ui'
export default {
  data() {
    return {
      nowTime:'',
      mapAll:'',
      topData:{},
      msg1: [
            {src:"./static/images/logintracing/ant1.png"},
            {src:"./static/images/logintracing/ant2.png"},
            {src:"./static/images/logintracing/ant3.png"},
            {src:"./static/images/logintracing/ant4.png"},
            {src:"./static/images/logintracing/ant5.png"},
          ],
      msg2: [
            {src:"./static/images/logintracing/ant6.png"},
            {src:"./static/images/logintracing/ant7.png"},
            {src:"./static/images/logintracing/ant8.png"},
            {src:"./static/images/logintracing/ant9.png"},
            {src:"./static/images/logintracing/ant10.png"},
          ]
    };
  },
  mounted() {
     this.nowTimes();
     this.drawLine();
     this.drawMap();
     this.getmapNumber();
     this.getTop();
   },
  created() {
  },
  computed:{

  },
  methods: {
    getMapData(){
      return new Promise(res => {
      this.$request.post('/front/api/queryCodeNum?type=province', {}, _result => {
      // console.log(_result);
      if (_result.status == 1) {
        res(_result.result);
      }else{
        res(e);
      }
      });
            });
    },
    getTop(){
      this.$request.post('/front/api/queryCodeNum?type=top', {}, res => {
        console.log(res)
        if (res.status == 1) {
          this.topData = res.result;
        }
      })
    },
    getMonth(){
      return new Promise(res => {
      this.$request.post('/front/api/queryCodeNum?type=month', {}, _result => {
      // console.log(_result);
      if (_result.status == 1) {
        res(_result.result);
      }else{
        res(e);
      }
      });
            });
    },
    getmapNumber(){
      this.$request.post('/front/api/queryCodeNum?type=all', {}, res => {
        // console.log(res);
        if (res.status == 1) {
          this.mapAll = res.result;
        }
      })
    },
    login(){
      this.$router.push({path:'/login'})
    },
    register(){
      this.$router.push({path:'/login/register'})
    },
    goodsList(){
      this.$router.push({path:'/goodslist'})
    },

    async drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChartMap = this.$echarts.init(document.getElementById('myChartMap'))
        let _data = await this.getMonth();
        var _data_x = _data.xAxis
        var _data_y = _data_y
        // 绘制图表
        myChartMap.setOption({
            xAxis: {
                type: 'category',
                boundaryGap: false,
                axisTick: {
                    show: false
                },
                splitLine:{
                  show: true,
                  lineStyle:{
                    color:["rgba(33,68,87,50%)"],
                    width: 2,
                    type: 'solid'
                  },
                },//去除网格线
                splitArea : {
                  show:false,
                  color:"rgb(0,162,165)"
                  },//保留网格区域
                //x轴数据
                data: _data.x,
                grid:{
                  broderColor:'rgb(0,162,165)'
                },
                axisLabel: {
                show: true,
                color: "rgb(0,162,165)",
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: 'rgb(66,82,123)',//左边线的颜色
                        width:'1'//坐标线的宽度
                    }
                },
              },
            yAxis: {
              type: 'value',
              scale : true,
              min : 0,
              splitNumber : 4,
              boundaryGap : [ 0.2, 0.2 ],
              axisTick: {
                    show: false
                },
              splitLine:{show: false},//去除网格线
              splitArea : {show : false},//保留网格区域
              axisLine: {
                  lineStyle: {
                      type: 'solid',
                      color: 'rgb(0,162,165)',//左边线的颜色
                      width:'0'//坐标线的宽度
                  }
              },
              axisLabel: {
                  textStyle: {
                      color: 'rgb(0,162,165)',//坐标值得具体的颜色

                  }
              }
            },
            series:[
            {
                name: '模拟数据',
                type: 'line',
                smooth: true,
                symbol: 'none',
                sampling: 'average',
                itemStyle: {
                    color: '#00a2a5'
                },
                areaStyle: {
                  //折线图区域颜色渐变
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1,[{
                        offset: 0, color: 'rgba(0,162,165,50%)' // 0% 处的颜色
                      }, {
                          offset: 1, color: 'rgba(0,162,165,10%)' // 100% 处的颜色
                      }]
                  ), //背景渐变色  
                },
                //y轴数据
                // data:y
                data:_data.y
            }
        ]
        });
    },
    async drawMap(){
      var myChart = this.$echarts.init(document.getElementById('myChart'));
      let cityData =await this.getMapData();
      var app ={}
        var option ={
            geo: [{
              roam: true,//设置为false,不启动roam就无所谓缩放拖曳同步了
              zoom:1.1,//缩放级别
            }],
            legend: { //图例组件。
                show:false,
                orient: 'vertical',
                y: 'bottom',
                x:'right',
                textStyle: {
                    color: '#fff'
                }
                    },
            //是视觉映射组件，用于进行『视觉编码』，也就是将数据映射到视觉元素（视觉通道）。
            // visualMap: {
            //     min: 0, //最小值
            //     max: cityMax, //最大值
            //     calculable: true, //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）。
            //     inRange: {
            //         color: ['#4cb0dd', '#2d79ad', '#265da0'] //颜色
            //     },
            //     textStyle: {
            //         color: '#fff'
            //     },
            // },
            // 提示框，鼠标移入
            tooltip:{
                show:true, //鼠标移入是否触发数据
                trigger: 'item', //触发方式
                formatter:'{b}-地区扫码：{c}'
            },   
            series:[
                {
                    name:'地图',
                    type: 'map',  //地图种类
                    map: 'china', //地图类型。
                    data:cityData,
                    showLegendSymbol:false,
                    //初始默认选中地图板块selected
                    itemStyle: { //地图区域的多边形 图形样式。
                        emphasis:{ //高亮状态下的样试
                            label:{
                                show:false,
                            }
                        },
                        //修改地图默认颜色
                        areaColor:"rgba(0,32,81,80%)",
                        //修改地图边框默认颜色
                        borderColor: 'rgba(41,130,219,70%)',
                        //地图边框默认颜色粗细
                        borderWidth:1,
                    },
                    zoom:1.2,//放大比例
                    label: {  //图形上的文本标签，可用于说明图形的一些数据信息
                        show:false,
                    },
                },
                {
                    type:'scatter',
                    showEffectOn: 'render',//配置什么时候显示特效
                    coordinateSystem:'geo',//该系列使用的坐标系
                    symbolSize:10,//标记的大小
                    data:[],
                    zlevel:99999
                },
              ]
              }
        myChart.setOption(option);
        app.currentIndex = -1;
        setInterval(function () {
              var dataLen = option.series[0].data.length;
              // 取消之前高亮的图形
              myChart.dispatchAction({
                  type: 'downplay',
                  seriesIndex: 0,
                  dataIndex: app.currentIndex
              });
              app.currentIndex = (app.currentIndex + 1) % dataLen;
              // 高亮当前图形
              myChart.dispatchAction({
                  type: 'highlight',
                  seriesIndex: 0,
                  dataIndex: app.currentIndex
              });
              // 显示 tooltip
              myChart.dispatchAction({
                  type: 'showTip',
                  seriesIndex: 0,
                  dataIndex: app.currentIndex
              });
          }, 1000);
    },
    nowTimes(){
      this.timeFormate(new Date());
    },
    //显示当前时间（年月日时分秒）
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
      let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
      let week = new Date(timeStamp).getDay();
      let weeks = ["日","一","二","三","四","五","六"];
      let getWeek = "星期" + weeks[week];
      this.nowTime = year + "年" + month + "月" + date +"日"+" "+getWeek  ;
    },
    }
};
</script>

<style lang="scss" scoped>
  .emptiy{
      width: 100%;
      height: 0.8rem;
    }
  .traceability{
    width: 100%;
    background-image: url("../../static/images/logintracing/tracingbj.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .provincial{
      color: #5ec4ff;
      display: flex;
      justify-content: space-between;
      padding: 0.1rem 0.4rem;
      ol{
        list-style-type:square;
        display: flex;
        .picmsg{
          .picmsgli{
            padding: 0.13rem 0 0.1rem 0;
            img{
              margin-right: 0.2rem;
              width: 0.3rem;
              height: 0.3rem;
            }
          }
        }
        li{
          padding: 0.1rem 0;
          display: flex;
          p{
            width: 1rem;
            display: block;
            text-overflow: ellipsis; //显示省略符号来代表被修剪的文本，也可以自定义
            overflow: hidden; //溢出内容隐藏
            white-space:nowrap; //强制文本在一行内显示
          }
          .provincialbj{
            background-image: url('../../static/images/logintracing/frequency.png');
            background-repeat:no-repeat;
            background-size: 100% 100%;
            padding: 1px 10px;
            margin-left: 10px;
            min-width: 1.2rem;
            max-width: 1.5rem;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .ranking{
      background-image: url("../../static/images/logintracing/line.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: #ffb260;
      padding: 3px 0;
    }
    .indexbtn{
        position: fixed;
        bottom: 0;
        width: 100%;
        background: #050f25;
      button{
        border: none;
        width: 49.4%;
        height: 0.8rem;
        background-color: #103068;
        color: #ffffff;
      }
      .indexyuan{
        // background-image: url("/static/images/logintracing/frequency.png");
        border: 3px solid rgb(32,214,212);
        background:radial-gradient(rgb(12,75,146),rgb(16,48,104));
      }
    }
    #myChart{
      width: 90%;
      height: 180px;;
      margin-left: 5%;
      background-image: url('../../static/images/logintracing/mapbj.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .drawline{
      width: 100%;
      height: 4rem;
      padding-bottom: 16px;
      #myChartMap{
        width: 98%;
        margin: 0 auto;
        height: 240px;
    }
    }
    .sweeptrend{
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #0efcff;
      padding-top: 0.4rem;
      .Sweep{
        background-image: url("../../static/images/logintracing/line.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 3px 0;
        .number{
          color: #0efcff;
          font-size: 18px;
        }
      }
    }
    .sweepnumber{
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #0efcff;
      padding-top: 0.4rem;
      .Sweep{
        padding: 2px;
        background-image: url("../../static/images/logintracing/line.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .number{
          color: #0efcff;
          font-size: 18px;
        }
      }
    }
    .headerfile{
      color: #9ae0ff;
      text-align: inherit;
      padding: 0 0 0 16px;
      display: flex;
      justify-content: space-between;
      .search{
        width: 1.9rem;
        height: 0.54rem;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        background: rgb(30,44,100);
        .bb{
          height: 0.06rem;
        }
        a{
          color:#ffb260;
          padding-left: 0.3rem;
          font-weight: bold;
        }
      }
    }
    .tracingtop{
      background: url("../../static/images/logintracing/tracingtop.png");
      background-repeat: no-repeat;
      background-size: 100%;
      text-align: center;
      height: 1rem;
      font-size: 0.35rem;
      color: rgb(14,252,255);
      p{
        font-weight: bold;
        padding-top: 0.2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue